import {UtilsArray} from "./utils/index.mjs";
import {GoogleMaps} from "@mecatran/map";





export class MapClient{
    constructor(dataSource, mapElement, mapClientOptions){
        var _mapClientOptions = mapClientOptions || {};
        var _mapOptions = ('mapOptions' in _mapClientOptions) ? _mapClientOptions.mapOptions : {};
        var _mapElement = mapElement;
        var _dataSource = dataSource;
        var _paginationSize = mapClientOptions.paginationSize || MapClient.paginationSize; 
        var _currentPageIndex = 0;
        var _googleMaps = new GoogleMaps(_mapElement, _mapOptions );
        var _debug = ('debug' in _mapClientOptions) ? _mapClientOptions.debug : 'false';

        Object.defineProperty(this,'getGoogleMaps',{
            value : ()=>_googleMaps
        });

        /* added on 31/05/2021 */
        Object.defineProperty(this,'setDataSource',{
            value : function(d){ _dataSource = d },
        })

        Object.defineProperty(this,'getData',{
            value : ()=>{ return _dataSource.get() }
        });

        Object.defineProperty(this,'getPageSize',{
            value : ()=>_paginationSize 
        });

        Object.defineProperty(this,'getCurrentPageIndex',{
            value : ()=>_currentPageIndex
        });

        Object.defineProperty(this,'nextPage',{
            value : ()=>{ _currentPageIndex++ }
        });

        Object.defineProperty(this,'previousPage',{
            value : ()=>{
                if (_currentPageIndex=0) return;
                _currentPageIndex--;
            }
        })

        if (_debug){ this.initDebug(); }




    }

    // ==========
    // private 
    // ----------
    getIconUrl(bool){
        if (bool) return "./assets/marker-school1.png";
        else return "./assets/marker-home1.png";
    }
/**
 * 
 * @param data type Stop 
 */
    createMarker(data){
        var labelText;
        // labelText = `${data.getName()} \r\n ${data.getCity()}`;
        labelText = data.getName() + '\r\n' + data.getCity();
        var isSchool = data.getIsDestination();
        var url = this.getIconUrl(isSchool);
        var size = [74, 104] //[37,52]; max size 
        var factor = 0.5;
        var marker = this.getGoogleMaps().createMarker(url, size, factor, labelText, data.getLatLon(), data );
        marker.setLabel(null)
        this.getGoogleMaps().getMarkerManager().addMarker(marker);
    }



    displayMarkers(){
        var googleMaps = this.getGoogleMaps();
        googleMaps.getMarkerManager().updateMarkers(googleMaps.addToMap.bind(googleMaps));
    }


    fitBounds(){
        var googleMaps = this.getGoogleMaps();
        var bounds = this.computeMarkersBounds2();
        console.log(bounds)
        googleMaps.fitBounds(bounds);
    }

    computeMarkersBounds(){
        var markerManager = this.getGoogleMaps().getMarkerManager();
        var bounds = markerManager.getBounds();
        return bounds;
    }

    computeMarkersBounds2(){
        var markerManager = this.getGoogleMaps().getMarkerManager();
        var markers = markerManager.getMarkers();
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < markers.length; i++ ){
            var markerPos = markers[i].getPosition();
            //console.log('markerPos', markerPos)
            bounds.extend(markerPos);
        }
        console.log('bounds',bounds)
        return bounds;
    }

    createMarkers(dataArray){
        UtilsArray.processAll(this.createMarker.bind(this))(dataArray);
        return;
    }

    removeMarkers(){
        var googleMaps = this.getGoogleMaps();
        var markerManager = googleMaps.getMarkerManager();
        markerManager.updateMarkers(googleMaps.removeFromMap.bind(googleMaps));
        markerManager.clear();
    }

    addMarkersEventListener(event, handler){
        var googleMaps = this.getGoogleMaps();
        var markerManager = googleMaps.getMarkerManager();
        markerManager.updateMarkers(googleMaps.addMarkerEventListener(event,handler));
    }

    initDebug(){
        window.googlemaps = this.getGoogleMaps();
    }

    filterByPage(dataArray){
        var index = this.getCurrentPageIndex();
        var size = this.getPageSize();
        var firstIndex = (index * size);
        var lastIndex = (index+1)*size;
        if (lastIndex > dataArray.length) lastIndex = dataArray.length;
        return dataArray.slice(firstIndex, lastIndex)
    }

    displayStops(dataArray){
        var googleMaps = this.getGoogleMaps();
        this.createMarkers(dataArray);
        this.addMarkersEventListener('click',googleMaps.onMarkerClick)
        this.displayMarkers()
        this.fitBounds();
    }



    findMarker(stop1){
        return (marker)=>{
            var stop2 = marker.getData();
            return ( stop1.getId() === stop2.getId() );
        }
    }

    stopMarkerAnimation(marker){
        marker.setAnimation(null);
    }


    // ==========
    // public 
    // ----------
    displayAllStops(){
        this.clearMap();
        this.getData()
                .then(this.displayStops.bind(this));
    }

    clearMap(){
        this.removeMarkers();
        return;
    }

    displayStopsByPage(){
        this.getData().then(this.filterByPage.bind(this))
                        .then(this.displayStops.bind(this));
    }

    stopAllMarkersAnimation(){
        var googleMaps = this.getGoogleMaps();
        var markerManager = googleMaps.getMarkerManager();
        var markers = markerManager.getMarkers();
        UtilsArray.processAll(this.stopMarkerAnimation.bind(this))(markers);     
    }


    getMarker(stop){
        var markerManager = this.getGoogleMaps().getMarkerManager()
        var markers = markerManager.getMarkers();
        return markers.find(this.findMarker(stop));
    }

    updateIconSize(stop, factor){
        var googleMaps = this.getGoogleMaps();
        var marker = this.getMarker(stop);
        googleMaps.updateMarkerIconSize(marker, factor);
    }

    

    // ==========
    // static
    // ----------
    static paginationSize = 20 
}


class MapClientOptions{
    constructor(){
        this.paginationSize;
        this.mapOptions; // check googleMaps.map.options 
        this.debug; 
    }
}